<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        企业合格率排行
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            v-if="operationSuper.导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.dateRange">
            <el-date-picker
              v-model="slotForms.forms.dateRange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd"
              :picker-options="datePickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="forms.comparyName">
            <el-input
              v-model="slotForms.forms.comparyName"
              placeholder="企业名称"
              clearable
            ></el-input>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
      >
        <div slot="empty" class="figure-data">
          <div class="nodate">
            <img src="../../assets/images/pg-nodata.png" alt="" />
          </div>
        </div>
        <el-table-column
          label="排名"
          width="80"
          align="center"
          fixed
          prop="orderNum"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          prop="comparyName"
          label="企业名称"
          min-width="160"
          fixed
          header-align="center"
          align="left"
        >
        </el-table-column>
        <el-table-column
          prop="comprehensiveQualifyRate"
          label="综合合格率(%)"
          min-width="120"
          header-align="center"
          align="right"
        >
          <template slot-scope="scope">
            <span>{{
              +(scope.row.comprehensiveQualifyRate * 100).toFixed(2)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="freezerMonitorPointCount"
          label="冷库监测点数量"
          min-width="150"
          header-align="center"
          align="right"
        >
        </el-table-column>
        <el-table-column
          prop="freezerQualifyRate"
          label="冷库合格率（%）"
          min-width="150"
          sortable
          header-align="center"
          align="right"
        >
          <template slot-scope="scope">
            <span>{{ +(scope.row.freezerQualifyRate * 100).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="leadStorageMonitorPointCount"
          label="前置仓监测点数量"
          min-width="150"
          header-align="center"
          align="right"
        >
        </el-table-column>
        <el-table-column
          prop="leadStorageQualifyRate"
          label="前置仓合格率（%）"
          min-width="150"
          sortable
          header-align="center"
          align="right"
        >
          <template slot-scope="scope">
            <span>{{
              +(scope.row.leadStorageQualifyRate * 100).toFixed(2)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="storeMonitorPointCount"
          label="门店监测点数量"
          min-width="150"
          header-align="center"
          align="right"
        >
        </el-table-column>
        <el-table-column
          prop="storeQualifyRate"
          label="门店合格率（%）"
          min-width="150"
          sortable
          header-align="center"
          align="right"
        >
          <template slot-scope="scope">
            <span>{{ +(scope.row.storeQualifyRate * 100).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="vehicleMonitorPointCount"
          label="车辆监测点数量"
          min-width="150"
          header-align="center"
          align="right"
        >
        </el-table-column>
        <el-table-column
          prop="vehicleQualifyRate"
          label="车辆合格率（%）"
          min-width="170"
          sortable
          header-align="center"
          align="right"
        >
          <template slot-scope="scope">
            <span>{{ +(scope.row.vehicleQualifyRate * 100).toFixed(2) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
  </div>
</template>

<script>
import {
  FetchFindComparyPassRateByPage,
  exportListByComparyPassRate
} from "@/api/report/passRate";
import { mapGetters, mapActions } from "vuex";
import resizeListener from "_private/mixins/resizeListener";
import operationManage from "_private/mixins/operationManage";
import { mergeFormExtend } from "_private/utils/merge";
import { datePickerOptionsNotContainToday } from "@/utils/dateHasDisable.js";
import { exportXlsx } from "@/utils/exportXlsx.js";
import moment from "moment";

export default {
  mixins: [resizeListener, operationManage],
  data() {
    return {
      total: 0,
      curPage: 1,
      pageSize: 20,
      isSearch: false,
      formExtend: {
        forms: {
          dateRange: [
            moment()
              .subtract(1, "day")
              .format("YYYY-MM-DD"),
            moment()
              .subtract(1, "day")
              .format("YYYY-MM-DD")
          ],
          comparyName: ""
        },
        extends: []
      },
      formsExtend: [],
      tableData: [],
      loading: "false",
      //导出URL
      exportUrl:
        "/report/companyQualifyRateRanking/exportCompanyQualifyRateRanking?",
      datePickerOptions: datePickerOptionsNotContainToday
    };
  },
  computed: {
    ...mapGetters(["moduleId", "searchFormIsOpen", "userId"])
  },
  created() {
    // 查询列表数据
    this.FetchFindByPage(this.mergeObj());
    this.setSearchFormIsOpenAct();
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),
    // 获取表格数据
    FetchFindByPage(response) {
      if (!response.dateRange) {
        this.$message.warning("开始时间与结束时间不能为空！");
        return false;
      }
      this.loading = true;
      response.beginTime = moment(response.dateRange[0])
        .startOf("day")
        .valueOf();
      response.endTime = moment(response.dateRange[1])
        .endOf("day")
        .valueOf();
      FetchFindComparyPassRateByPage(response)
        .then(response => {
          if (
            response.result &&
            response.result.data &&
            Array.isArray(response.result.data)
          ) {
            this.tableData = response.result.data;
            this.total = response.result.totalRecords;
          }
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
    // 整合查询数据
    mergeObj() {
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        pageParamVO: {
          sortIndx: "comprehensiveQualifyRate",
          sortDir: "desc",
          curPage: this.curPage,
          pageSize: this.pageSize
        }
      });
    },
    // 导出excel 表格
    handleExport() {
      let params = this.searchData;
      this.exportData(params);
    },
    // 导出页面数据接口请求
    async exportData(params) {
      try {
        exportListByComparyPassRate(params).then(res => {
          // 导出
          exportXlsx(res, `企业合格率排行.xls`);
        });
      } catch (err) {
        console.log(err);
      }
    },
    // 是否查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
      });
    },
    // 查询数据
    handlesSubmitForm() {
      this.curPage = 1;
      this.FetchFindByPage(this.mergeObj());
    },
    // 翻页
    handleCurrentChange(e) {
      this.curPage = e;
      this.FetchFindByPage(this.mergeObj());
    },
    // 设置每页多少条
    handleSizeChange(e) {
      this.pageSize = e;
      this.FetchFindByPage(this.mergeObj());
    },
    //导出
    handleExportClick() {
      let param = "";
      if (
        this.formExtend.forms.dateRange !== null &&
        this.formExtend.forms.dateRange !== ""
      ) {
        param +=
          "&beginTime=" +
          moment(this.formExtend.forms.dateRange[0])
            .startOf("day")
            .valueOf();
        param +=
          "&endTime=" +
          moment(this.formExtend.forms.dateRange[1])
            .endOf("day")
            .valueOf();
        param += "&comparyName=" + this.formExtend.forms.comparyName;
        document.location.href = this.exportUrl + param;
      } else {
        this.$message({
          showClose: true,
          message: "开始时间与结束时间不能为空！",
          type: "warning"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}

.links {
  color: #0000ff;
  cursor: pointer;
}

/deep/ .el-button--primary {
  .e6-icon-export_line,
  .e6-icon-set-up_fill {
    color: #fff !important;
  }
}
</style>
